import {
  getPermissionScope,
  hasPermission,
  maxPermissionScope,
  PermissionKey,
  type PermissionMap,
  PermissionScope,
} from "@fitness-app/data-models";

/**
 * Kto potrzebuje listy zespołu w panelu.
 *
 * Roster nie służy tu do zarządzania zespołem — zasila filtry „Trener" na
 * listach klientek, selektory autora wiadomości i pickery przypisania. Dlatego
 * nie wystarczy pytać o `team.read`: ten klucz ma w katalogu WYŁĄCZNIE
 * ACCOUNT_OWNER, więc bramka na nim samym zabiera roster administracji
 * i head coachowi, choć oboje prowadzą klientki i muszą widzieć, kto jest ich
 * trenerem. Kto czyta klientki poza własnym przydziałem, ten potrzebuje też
 * nazwisk trenerów.
 */
export const needsTeamRoster = (permissions: PermissionMap): boolean =>
  hasPermission(permissions, PermissionKey.TEAM_READ) ||
  hasPermission(permissions, PermissionKey.CLIENTS_READ, PermissionScope.TEAM);

/**
 * Czy roster ma się ograniczyć do przypisanych trenerów (head coach), czy objąć
 * całe konto. To ten sam wycinek, który `fetchTeamMembers` / `subscribeToTeam`
 * dostawały wcześniej jako `isHeadCoach`.
 */
export const rosterLimitedToAssigned = (permissions: PermissionMap): boolean =>
  maxPermissionScope(
    getPermissionScope(permissions, PermissionKey.TEAM_READ),
    getPermissionScope(permissions, PermissionKey.CLIENTS_READ),
  ) === PermissionScope.TEAM;
